import type { Account } from "../accounts";

interface Props {
  accounts: Account[];
  selectedId: string | null;
  onSelect: (account: Account) => void;
}

/**
 * The account picker: the first thing on screen.
 *
 * Same cards as the bot picker, because it is the same gesture one step
 * earlier - pick a thing, move on. Selecting is what loads the bots, so
 * nothing is fetched until someone has said which account they mean.
 */
export function AccountGrid({ accounts, selectedId, onSelect }: Props) {
  if (!accounts.length) {
    return <p className="muted">No accounts configured.</p>;
  }

  return (
    <div className="grid" role="radiogroup" aria-label="Accounts">
      {accounts.map((account) => {
        const selected = selectedId === account.id;
        return (
          <button
            key={account.id}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`pod ${selected ? "selected" : ""}`}
            onClick={() => onSelect(account)}
          >
            <span className="pod-top">
              <span className="pod-icon" aria-hidden="true">
                {account.name.slice(0, 2).toUpperCase()}
              </span>
              {selected && (
                <span className="pod-check" aria-hidden="true">
                  {"✓"}
                </span>
              )}
            </span>

            <span className="pod-name">{account.name}</span>
            <span className="pod-desc">{account.description}</span>
          </button>
        );
      })}
    </div>
  );
}
